<template>
	<l-map
		v-model="zoom"
		v-model:zoom="zoom"
		:center="coordinates"
		:options="options"
		zoom-animation
		fade-animation
		marker-zoom-animation
	>
		<l-tile-layer :url="url" :attribution="attribution" />
		<l-marker :draggable="isEditing" :lat-lng="coordinates" @update:latLng="onChange" />
		<l-control position="topright" v-if="editable">
			<app-button
				v-if="!isEditing"
				icon="pencil"
				class="btn btn-primary transparent small ml-2"
				@click="editMarker"
			/>
			<app-button v-if="isEditing" icon="save" class="btn btn-primary transparent small ml-2" @click="save" />
		</l-control>
	</l-map>
</template>

<script>
	import { LControl, LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet';
	import 'leaflet/dist/leaflet.css';
	import { cartoLightSource, mapAttribution } from '@/constants/mapTiles';

	export default {
		name: 'AppMapImage',
		props: ['coordinates', 'editable'],
		emits: ['updateAddress'],
		components: { LControl, LMap, LTileLayer, LMarker },
		data: () => ({
			isEditing: false,
			url: cartoLightSource,
			attribution: mapAttribution,
			zoom: 17,
			options: {
				zoomControl: false,
			},
			newCoordinates: {},
		}),
		methods: {
			editMarker() {
				this.isEditing = true;
			},
			onChange(coords) {
				this.newCoordinates = coords;
			},
			save() {
				this.isEditing = false;
				this.$emit('updateAddress', this.newCoordinates);
			},
		},
	};
</script>
